<template>
	<div class="omapi-datepicker-input">
		<label v-if="label">{{ label }}</label>
		<el-date-picker
			type="daterange"
			unlink-panels
			start-placeholder="Start date"
			end-placeholder="End date"
			format="MMM d, yyyy"
			ref="datepicker"
			:picker-options="pickerOptions"
			:clearable="false"
			:align="align"
			v-model="dateSelection"
		/>
	</div>
</template>

<script>
import moment from 'moment'
import '@/components/core/form/datepicker-variables.scss'

export default {
	name  : 'DatepickerInput',
	props : {
		label : {
			type    : String,
			default : '',
		},
		align : {
			type    : String,
			default : 'left',
		},
		openImmediate : {
			type    : Boolean,
			default : false,
		},
		dateRange : {
			type     : Array,
			required : true,
		},
	},
	data () {
		return {
			pickerOptions : {
				shortcuts : [
					{
						text : 'Today',
						onClick (picker) {
							const start = moment()
							const end   = moment()
							picker.$emit('pick', [ start, end ])
						},
					},
					{
						text : 'Yesterday',
						onClick (picker) {
							const start = moment().subtract(1, 'days')
							const end   = moment().subtract(1, 'days')
							picker.$emit('pick', [ start, end ])
						},
					},
					{
						text : 'Last Week',
						onClick (picker) {
							const start = moment().subtract(1, 'weeks').startOf('week')
							const end   = moment().subtract(1, 'weeks').endOf('week')
							picker.$emit('pick', [ start, end ])
						},
					},
					{
						text : 'This Month',
						onClick (picker) {
							const start = moment().startOf('month')
							const end   = moment().endOf('today')
							picker.$emit('pick', [ start, end ])
						},
					},
					{
						text : 'Last Month',
						onClick (picker) {
							const start = moment().subtract(1, 'months').startOf('month')
							const end   = moment().subtract(1, 'months').endOf('month')
							picker.$emit('pick', [ start, end ])
						},
					}, {
						text : 'Last 3 Months',
						onClick (picker) {
							const start = moment().subtract(3, 'months').startOf('month')
							const end   = moment().subtract(1, 'months').endOf('month')
							picker.$emit('pick', [ start, end ])
						},
					},
				],
				disabledDate : this.disabledDate,
			},
		}
	},
	computed : {
		dateSelection : {
			get () {
				return  this.dateRange
			},
			set (newValue) {
				this.$emit('input', newValue)
			},
		},
	},
	methods : {
		disabledDate (time) {
			return time.getTime() > Date.now() || time.getTime() < this.$moment(this.minDate, 'YYYY-MM-DD').valueOf()
		},
	},
	mounted () {
		if  (this.openImmediate) {
			this.$refs.datepicker.focus()
		}
	},
}
</script>

<style lang="scss">
	.omapi-datepicker-input {
		text-align: left;
		label {
			font-size: 18px;
			font-weight: bold;
			margin-bottom: 10px;
		}
	}
</style>
